import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CustomDirectivesModule } from "@app/_directives/custom-directives.module";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { CreateTaskDialogModule } from "../create-task-dialog/create-task-dialog.module";
import { TaskPickerDialogComponent } from "./task-picker-dialog.component";
import { TaskPickerEntryComponent } from "./task-picker-entry/task-picker-entry.component";

@NgModule({
	declarations: [TaskPickerDialogComponent, TaskPickerEntryComponent],
	imports: [
		CommonModule,
		MaterialModule,

		FormsModule,
		ReactiveFormsModule,
		CustomDirectivesModule,
		TranslateModule,
		RouterModule,
		ScrollingModule,
		CreateTaskDialogModule,
	],
	exports: [TaskPickerDialogComponent],
})
export class TaskPickerDialogModule {}
